import React, { useEffect, useRef, useState } from "react";
import { Share2, Download, IdCard } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { dateLabel } from "../lib/format";

const W = 720, H = 420;

/* Mini member ID card drawn on canvas → share (WhatsApp / Web Share) or save. */
export const CustomerIdCard = ({ user }) => {
  const [agent, setAgent] = useState(null);
  const [url, setUrl] = useState("");
  const ref = useRef(null);
  useEffect(() => { api.get("/auth/my-agent").then((r) => setAgent(r.data.agent)).catch(() => {}); }, []);

  useEffect(() => {
    if (!user) return;
    const c = ref.current; const x = c.getContext("2d");
    const g = x.createLinearGradient(0, 0, W, H); g.addColorStop(0, "#0f172a"); g.addColorStop(1, "#1e293b");
    x.fillStyle = g; x.beginPath(); x.roundRect(0, 0, W, H, 28); x.fill();
    x.fillStyle = "#f59e0b"; x.fillRect(0, 0, W, 10);
    x.fillStyle = "#fbbf24"; x.font = "900 34px Georgia, serif"; x.fillText("👑 ROYAL LAKSHMI", 40, 70);
    x.fillStyle = "#94a3b8"; x.font = "600 16px sans-serif"; x.fillText("MEMBER ID CARD", 42, 98);
    x.fillStyle = "#ffffff"; x.font = "900 40px sans-serif"; x.fillText((user.name || "Player").slice(0, 22), 40, 170);
    x.fillStyle = "#cbd5e1"; x.font = "600 22px monospace"; x.fillText(`+91 ${user.mobile}`, 40, 206);
    const rows = [["Member code", user.referral_code || "-"], ["Joined", dateLabel(user.created_at)], ["Agent", agent ? `${agent.name} · ${agent.mobile}` : "ROYAL LAKSHMI direct"]];
    rows.forEach(([k, v], i) => { const y = 268 + i * 44; x.fillStyle = "#64748b"; x.font = "600 15px sans-serif"; x.fillText(k.toUpperCase(), 40, y); x.fillStyle = "#f8fafc"; x.font = "800 22px sans-serif"; x.fillText(String(v), 230, y); });
    x.fillStyle = "#f59e0b"; x.beginPath(); x.arc(W - 90, 110, 56, 0, Math.PI * 2); x.fill();
    x.fillStyle = "#0f172a"; x.font = "900 48px sans-serif"; x.textAlign = "center"; x.fillText((user.name || "P")[0].toUpperCase(), W - 90, 128); x.textAlign = "left";
    x.fillStyle = "#475569"; x.font = "500 13px sans-serif"; x.fillText(window.location.origin.replace(/^https?:\/\//, ""), 40, H - 24);
    setUrl(c.toDataURL("image/png"));
  }, [user, agent]);

  const text = `👑 ROYAL LAKSHMI — Member ID\n${user.name}\n+91 ${user.mobile}\nCode: ${user.referral_code}\nJoined: ${dateLabel(user.created_at)}\nAgent: ${agent ? `${agent.name} (${agent.mobile})` : "ROYAL LAKSHMI direct"}`;
  const toFile = async () => { const b = await (await fetch(url)).blob(); return new File([b], "royal-laxmi-id.png", { type: "image/png" }); };
  const share = async () => {
    try {
      const f = await toFile();
      if (navigator.canShare && navigator.canShare({ files: [f] })) await navigator.share({ files: [f], text, title: "ROYAL LAKSHMI Member ID" });
      else window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
    } catch (e) { if (e.name !== "AbortError") window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank"); }
  };
  const save = () => { const a = document.createElement("a"); a.href = url; a.download = "royal-laxmi-id.png"; a.click(); toast.success("ID card saved"); };

  return (
    <div className="rl-card p-4" data-testid="customer-id-card">
      <div className="flex items-center gap-2 mb-2 font-bold text-slate-900 text-sm"><IdCard className="w-4 h-4 text-amber-600" />My Member ID card</div>
      <canvas ref={ref} width={W} height={H} className="w-full rounded-2xl shadow-lg" data-testid="customer-id-canvas" />
      <div className="flex gap-2 mt-3">
        <button onClick={share} className="flex-1 py-2.5 rounded-xl text-xs font-black bg-emerald-600 text-white flex items-center justify-center gap-1" data-testid="id-card-share"><Share2 className="w-4 h-4" />Share on WhatsApp</button>
        <button onClick={save} className="flex-1 py-2.5 rounded-xl text-xs font-black rl-card text-slate-800 flex items-center justify-center gap-1" data-testid="id-card-save"><Download className="w-4 h-4" />Save</button>
      </div>
    </div>
  );
};
